import ModalPDFViewer from "../../handlebars/templates/modal/pdf-viewer.hbs"
import ModalVideoViewer from "../../handlebars/templates/modal/video-viewer.hbs"

class @App.Components.TedEdModal
  $body = $('body')
  $modalWrapper = $('#teded-modal-wrapper').first()
  nextPgSelector = '[data-action="modal-next-pg"]'
  pageSelector = '[data-modal-page]'
  hiddenClass = "hidden"
  mobileWidth = 979

  constructor: ->
    $body.on 'click', '[data-action="close-modal"]', (e) =>
      e.preventDefault
      $modal = $(e.target).closest('#teded-modal-wrapper')
      $modal.fadeOut().html('')
      $body.trigger 'App::TedEdModal::close', [$modal]
      $body.removeClass 'teded-modal--active'
      $(window).off 'hashchange', @.hashchangeCloseModal
      newHash = location.hash.replace(/-modal/i, '').replace(/modal/i, '')
      history.replaceState('', '', newHash)
      false

    $body.on 'App::BetterModals::close App::TedEdModal::close', (e, $modal) ->
      $pages = $modal.find(pageSelector)
      $pages.addClass(hiddenClass)
      $pages.first().removeClass(hiddenClass)

    $body.on 'click', nextPgSelector, (e) =>
      $pg = $(e.currentTarget).closest(pageSelector)
      $next = $pg.next(pageSelector)
      if $next.length > 0
        $pg.addClass(hiddenClass);
        $pg.next(pageSelector).removeClass(hiddenClass);

    $body.on 'click', '[data-action="open-modal"]', (e) =>
      $element = $(e.target)

      # if mobile, don't pop modal, let default event occur
      if ($element.data('modal-type') == 'file')
        if ($( window ).width() <= mobileWidth)
          $element.attr 'target', '_blank'
          return

      e.preventDefault

      modalContent = ''
      $body.addClass 'teded-modal--active'

      $(window).on 'hashchange', @.hashchangeCloseModal

      if ($element.data('modal-type') == 'file')
        modalContent = ModalPDFViewer(
          title: $element.attr('title')
          filepath: $element.attr('href')
        )
      else if ($element.data('youtube-id'))
        modalContent = ModalVideoViewer({
          youtube_id: $element.data('youtube-id')
        })

      newHash = location.hash.replace(/-modal/i, '').replace(/modal/i, '')
      if newHash.length > 1
        newHash = newHash + '-modal'
      else
        newHash = '#modal'

      history.pushState('', '', newHash)

      if ($modalWrapper.length < 1)
        $modal = $('<div id="teded-modal-wrapper" />').addClass('teded-modal__wrapper')
        $body.append($modal)
        $modalWrapper = $modal

      $modalWrapper.html(modalContent)
      $modalWrapper.fadeIn()
      false

  hashchangeCloseModal: (e) ->
    if ( $modalWrapper.is(':visible') )
      $modalWrapper.find('[data-action="close-modal"]').click()

$ ->
  new App.Components.TedEdModal
